export enum ProductType {
  CREDIT_BUNDLE = 'PRODUCT_TYPE_CREDIT_BUNDLE',
  SERVICE_LABOUR = 'PRODUCT_TYPE_SERVICE_LABOUR',
  SERVICE_MATERIALS = 'PRODUCT_TYPE_SERVICE_MATERIALS',
  UNKNOWN = 'PRODUCT_TYPE_UNKNOWN',
}

export enum GroupType {
  UNKNOWN = 0,
  ACTIVATE_CHANNEL = 1,
  ACTIVATE_WHITELABEL = 2,
}

export interface ProductCategory {
  description: string;
  id: string;
  groupId: string;
  name: string;
  productType: ProductType;
  groupType: GroupType;
}
